import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import OnlineOrderFormProps from "../../services/models/formModels/OnlineOrderForm.model";
import useStateAndCity from "../../services/utils/custom hooks/useStateAndCity";
import { optionType } from "../organism/CustomSelect";

function ContactInfoFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  setFieldValue,
  getFieldMeta,
  disabled,
}: OnlineOrderFormProps): JSX.Element {
  const { data } = useStateAndCity();
  const stateCities = data?.find((state: any) => {
    return state.state_code === values.state;
  })?.cities;
  const cities = stateCities?.map(
    (city: any): optionType => ({ label: city.name, value: city.name })
  );
  const states: optionType[] = data?.map((state: any) => ({
    label: state.name,
    value: state.state_code,
  }));

  return (
    <FieldRenderer
      fields={dataConstants.contactInfoFields.map((field, index) => {
        // if (field?.isForm?.name === 'state' || field?.isForm?.name === 'org.state') {
        //   return {
        //     options: states,
        //     isForm: {
        //       ...field.isForm,
        //       labelInfo: {
        //         ...field.isForm.labelInfo,
        //       },
        //       setFieldValue,
        //       errors,
        //       values,
        //       getFieldMeta,
        //       touched,
        //       parentContainerClass: "!w-[48%] mx-1 my-3 mt-4 h-[20px]",
        //     },
        //   }
        // }
        if (field.name === "city")
          return {
            key: `${index}${field.labelInfo?.inputId}`,
            ...field,
            setFieldValue,
            getFieldMeta,
            values,
            "data-dd-privacy": "mask",
            // "data-openreplay-obscured": true,
            errors: errors,
            disabled: disabled,
            touched: touched,
            onChange: handleChange,
            value: values?.[!!field?.name ? field.name : ""],
            onBlur: handleBlur,
            name: field.name,
            roundedInput: true,
            parentContainerClass: [
              "city",
              "state",
              "phone",
              "zipcode",
            ].includes?.(field?.name ? field.name : "")
              ? "md:!w-[48%] mx-1"
              : "",
            suggestions: cities,
          };
        return {
          key: `${index}${field.labelInfo?.inputId}`,
          ...field,
          setFieldValue,
          getFieldMeta,
          values,
          errors: errors,
          touched: touched,
          // "data-openreplay-obscured": true,
          "data-dd-privacy": "mask",
          onChange: handleChange,
          value: values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: field.name,
          disabled: disabled,
          roundedInput: true,
          parentContainerClass: [
            "city",
            "state",
            "phone",
            "zipcode",
          ].includes?.(field?.name ? field.name : "")
            ? "md:!w-[48%] mx-1"
            : "",
        };
      })}
    />
  );
}

export default ContactInfoFields;
